'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@heroui/react';
import { LucideAlertTriangle, RefreshCcwIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
import { cn } from '@/lib/utils';
interface InfiniteListDefaultErrorViewProps extends ComponentProps<'div'> {
  error: Error | null;
  retry?: () => void;
}
export function InfiniteListDefaultErrorView(t0) {
  const $ = _c(12);
  const {
    error,
    retry,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("size-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmptyMedia variant="icon"><LucideAlertTriangle /></EmptyMedia>;
    t3 = <EmptyTitle>Erro ao carregar.</EmptyTitle>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = String(error?.message);
  let t5;
  if ($[4] !== t4) {
    t5 = <EmptyHeader>{t2}{t3}<EmptyDescription className="max-w-xs text-pretty">{t4}</EmptyDescription></EmptyHeader>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== retry) {
    t6 = !!retry && <EmptyContent><Button variant="bordered" onPress={retry} startContent={<RefreshCcwIcon className="size-4" />}>Tentar novamente</Button></EmptyContent>;
    $[6] = retry;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t5 || $[10] !== t6) {
    t7 = <Empty className={t1}>{t5}{t6}</Empty>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}